// extracted by mini-css-extract-plugin
export default {"pagination":"_2rVZ9","arrow":"_1nx0g"};